import api from "../../api/api";

class GlobalService {
    async getStatus() {
        const res = await api().get(`competition/status`)
        return res
    }

    async getList(date) {
        const res = await api().get(`competition/competitions?year=${date.year}&month=${date.month}`);
        return res
    }

    async chooseSelect(id) {
        return await api().get(`competition/select/${id}`)
    }
}

export default new GlobalService()
